import create, { SetState, StateCreator, StoreApi } from "zustand";

interface IPatientProfileStore {
  clearStore: () => void;
  patientList: any;
  setPatientList: (x: any) => void;
  patientData: any;
  setPatientData: (x: any) => void;
  patientPersonalData: any;
  setPatientPersonalData: (x: any) => void;
  patientTransactionalDetails: any;
  setPatientTransactionalDetails: (x: any) => void;
  patientPersonalDataGroup: any;
  setPatientPersonalDataGroup: (x: any) => void;
  patientTransactionalDataGroup: any;
  setPatientTransactionalDataGroup: (x: any) => void;
  patientOptionalData: any;
  setPatientOptionalData: (x: any) => void;
  summaryData: any;
  setSummaryData: (x: any) => void;
  dropDownOptions: any;
  setDropDownOptions: (x: any) => void;
  isPatientListLoading: any;
  setIsPatientListLoading: (x: any) => void;
  isPatientProfileLoading: any;
  setIsPatientProfileLoading: (x: any) => void;
  searchedName: any;
  setSearchedName: (x: any) => void;
  searchedId: any;
  setSearchedId: (x: any) => void;
  activePatientId: any;
  setActivePatientId: (x: any) => void;
  selectedOptions: any;
  setSelectedOptions: (x: any) => void;
  searchText: any;
  setSearchText: (x: any) => void;
  searchedColumn: any;
  setSearchedColumn: (x: any) => void;
  page: number;
  setPage: (x: number) => void;
  pageSize: number;
  setPageSize: (x: number) => void;
  sort: any;
  setSort: (x: any) => void;
  memberDetailsAttributedPcpNameLetest: string;
  setMemberDetailsAttributedPcpNameLetest: (x: string) => void;
  memberDetailsAttributedOfficeNameLetest: string; 
  setMemberDetailsAttributedOfficeNameLetest: (x: string) => void;
  dod: string;
  setdod: (x: string) => void;
  memberPageLoader: boolean;
  setMemberPageLoader: (x: boolean) => void;
  registryDependentProgramsStatus: any;
  setRegistryDependentProgramsStatus: (x: any) => void;
}

let store: StateCreator<IPatientProfileStore, [], [], IPatientProfileStore> | StoreApi<IPatientProfileStore> = (set: SetState<IPatientProfileStore>) => ({
  patientList: [],
  setPatientList: (x) => {
    set(() => ({ patientList: x }));
    },
    patientData: [],
  setPatientData: (x) => {
    set(() => ({ patientData: x }));
  },
  patientPersonalData: [],
  setPatientPersonalData: (x) => {
    set(() => ({ patientPersonalData: x }));
  },
  patientTransactionalDetails: [],
  setPatientTransactionalDetails: (x) => {
    set(() => ({ patientTransactionalDetails: x }));
  },
    patientOptionalData: [],
    setPatientOptionalData: (x) => {
    set(() => ({ patientOptionalData: x }));
  },
  searchedColumn: "",
    setSearchedColumn: (x) => {
    set(() => ({ searchedColumn: x }));
  },
  searchText: "",
  setSearchText: (x) => {
    set(() => ({ searchText: x }));
  },
  selectedOptions: null,
  setSelectedOptions: (x) => {
    set(() => ({ selectedOptions: x }));
  },
  activePatientId: "",
  setActivePatientId: (x) => {
    set(() => ({ activePatientId: x }));
  },
  searchedId: "",
  setSearchedId: (x) => {
    set(() => ({ searchedId: x }));
  },
  searchedName: "",
  setSearchedName: (x) => {
    set(() => ({ searchedName: x }));
  },
  isPatientProfileLoading: false,
  setIsPatientProfileLoading: (x) => {
    set(() => ({ isPatientProfileLoading: x }));
  },
  isPatientListLoading: false,
  setIsPatientListLoading: (x) => {
    set(() => ({ isPatientListLoading: x }));
  },
  dropDownOptions: [],
  setDropDownOptions: (x) => {
    set(() => ({ dropDownOptions: x }));
  },

  summaryData: [],
  setSummaryData: (x) => {
    set(() => ({ summaryData: x }));
  },
  page: 1,
    setPage: (x) => {
    set(() => ({ page: x }));
  },
  pageSize: 5,
    setPageSize: (x) => {
    set(() => ({ pageSize: x }));
  },
  sort: {
    column: "patient_name",
    order: "ascend"
  },
  setSort: (x) => {
    set(() => ({ sort: x }));
  },
  patientPersonalDataGroup: [],
  setPatientPersonalDataGroup: (x) => {
    set(() => ({ patientPersonalDataGroup: x }));
  },
  patientTransactionalDataGroup: [],
  setPatientTransactionalDataGroup: (x) => {
    set(() => ({ patientTransactionalDataGroup: x }));
  },
  memberDetailsAttributedPcpNameLetest: "",
  setMemberDetailsAttributedPcpNameLetest: (x) => {
    set(() => ({ memberDetailsAttributedPcpNameLetest: x }));
  },
  memberDetailsAttributedOfficeNameLetest: "",
  setMemberDetailsAttributedOfficeNameLetest: (x) => {
    set(() => ({ memberDetailsAttributedOfficeNameLetest: x }));
  },
  registryDependentProgramsStatus:[],
  setRegistryDependentProgramsStatus: (x) => {
    set(() => ({ registryDependentProgramsStatus: x }));
  },
  dod: "--",
  setdod: (dod) => {
    set(() => ({ dod }))
  },
  memberPageLoader: false,
  setMemberPageLoader: (x) => {
    set(() => ({ memberPageLoader: x }));
  },
  clearStore: () => {
    set(() => ({ patientList: [] }));
    set(() => ({ patientData: [] }));
    set(() => ({ patientPersonalData: [] }));
    set(() => ({ patientTransactionalDetails: [] }));
    set(() => ({ patientOptionalData: [] }));
    set(() => ({ searchedColumn: "" }));
    set(() => ({ searchText: "" }));
    set(() => ({ selectedOptions: null }));
    set(() => ({ activePatientId: "" }));
    set(() => ({ searchedId: "" }));
    set(() => ({ searchedName: "" }));
    set(() => ({ isPatientProfileLoading: false }));
    set(() => ({ isPatientListLoading: false }));
    set(() => ({ dropDownOptions: [] }));
    set(() => ({ summaryData: [] }));
    set(() => ({ page: 1 }));
    set(() => ({ pageSize: 5 }));
    set(() => ({ patientPersonalDataGroup: [] }));
    set(() => ({ patientTransactionalDataGroup: [] }));
    set(() => ({ memberDetailsAttributedPcpNameLetest: "" }));
    set(() => ({ memberDetailsAttributedOfficeNameLetest: "" }));
    set(() => ({ dod: "--" }));
    set(() => ({ memberPageLoader: false }));
    set(() => ({ registryDependentProgramsStatus: [] }));
    set(() => ({ sort: { column: "patient_name", order: "ascend" } }));
  },
});

export const usePatientProfileStore = create(store);
